/*
 * Lunvelis Partners · selección de servicios de Lunvelis World.
 * Esta tienda (Partners) no vende productos: los servicios, precios y el pago viven en lunvelis.world.
 * La selección guarda en este dispositivo los servicios elegidos (con su variante y cantidad), calcula
 * subtotales y totales con los precios publicados y, al continuar, los añade al carrito de Lunvelis World
 * mediante el enlace oficial /cart/add. No cobra nada ni crea pedidos desde Partners.
 */
(() => {
  if (window.LunvelisSelection) return;
  const KEY = 'lp.selection.v1';
  const WORLD = 'https://lunvelis.world';
  const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
  const toast = (options) => (window.LunvelisUI ? window.LunvelisUI.toast(options) : null);

  const read = () => {
    try { const list = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(list) ? list.filter((item) => item && item.variant && Number.isFinite(item.price) && item.qty > 0) : []; } catch (error) { return []; }
  };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (error) { /* sin almacenamiento */ } document.dispatchEvent(new CustomEvent('lp:selection')); };

  const api = {
    items: read,
    has: (variant) => read().some((item) => String(item.variant) === String(variant)),
    add(item) {
      const list = read();
      const found = list.find((entry) => String(entry.variant) === String(item.variant));
      if (found) found.qty = Math.min(10, found.qty + 1); else list.push({ qty: 1, ...item });
      write(list);
    },
    remove(variant) { write(read().filter((item) => String(item.variant) !== String(variant))); },
    setQty(variant, qty) { write(read().map((item) => (String(item.variant) === String(variant) ? { ...item, qty: Math.max(1, Math.min(10, qty)) } : item))); },
    clear() { write([]); },
    count: () => read().reduce((sum, item) => sum + item.qty, 0),
    total: () => read().reduce((sum, item) => sum + item.price * item.qty, 0),
    link() {
      const list = read();
      const parts = list.map((item, index) => `items[${index}][id]=${encodeURIComponent(item.variant)}&items[${index}][quantity]=${item.qty}`);
      return `${WORLD}/cart/add?${parts.join('&')}&return_to=${encodeURIComponent('/cart')}`;
    },
    format: (value) => money.format(value)
  };
  window.LunvelisSelection = api;

  const el = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };

  /* Pinta la lista (en el panel o en la página del carrito). */
  const paint = (host, foot) => {
    const list = read();
    host.replaceChildren();
    if (foot) foot.replaceChildren();
    if (!list.length) {
      const empty = el('div', 'lp-sel__empty');
      empty.append(el('p', '', 'Aún no has elegido servicios. Explora el catálogo de Lunvelis World y usa «Añadir a mi selección».'));
      const link = el('a', 'lp-btn lp-btn--dark-glass lp-btn--sm', 'Ver el catálogo');
      link.href = '/pages/partners-services#catalogo';
      link.style.marginBlockStart = '14px';
      empty.append(link);
      host.append(empty);
      return;
    }
    const wrap = el('div', 'lp-sel');
    for (const item of list) {
      const row = el('article', 'lp-sel__item');
      const info = el('div');
      const title = el('h3', '', item.title);
      const small = el('small', '', [item.area, item.kind].filter(Boolean).join(' · '));
      info.append(title, small);
      row.append(info, el('div', 'lp-sel__price', money.format(item.price * item.qty)));
      const controls = el('div', 'lp-sel__row');
      const qty = el('div', 'lp-qty');
      const minus = el('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', `Quitar una unidad de ${item.title}`); minus.disabled = item.qty <= 1;
      const output = el('output', '', String(item.qty)); output.setAttribute('aria-live', 'polite');
      const plus = el('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', `Añadir una unidad de ${item.title}`); plus.disabled = item.qty >= 10;
      minus.addEventListener('click', () => api.setQty(item.variant, item.qty - 1));
      plus.addEventListener('click', () => api.setQty(item.variant, item.qty + 1));
      qty.append(minus, output, plus);
      const remove = el('button', 'lp-sel__remove', 'Quitar'); remove.type = 'button'; remove.setAttribute('aria-label', `Quitar ${item.title} de la selección`);
      remove.addEventListener('click', () => { api.remove(item.variant); toast({ type: 'info', id: 'sel-removed', title: 'Servicio quitado', message: item.title }); });
      controls.append(qty, remove);
      row.append(controls);
      wrap.append(row);
    }
    const total = el('div', 'lp-sel__total');
    const units = api.count();
    const sub = el('div'); sub.append(el('span', '', `Subtotal · ${units} ${units === 1 ? 'servicio' : 'servicios'}`), el('span', '', money.format(api.total())));
    const note = el('div'); note.append(el('span', '', 'Impuestos y pago'), el('span', '', 'en Lunvelis World'));
    const grand = el('div'); grand.append(el('span', '', 'Total de tu selección'), el('span', '', money.format(api.total())));
    total.append(sub, note, grand);
    wrap.append(total);
    host.append(wrap);
    const actions = foot || host;
    const go = el('a', 'lp-btn lp-btn--dark-glass', 'Continuar en Lunvelis World');
    go.append(' ', Object.assign(el('span', 'lp-btn__arrow', '↗'), { ariaHidden: 'true' }));
    go.href = api.link(); go.rel = 'noopener'; go.target = '_blank';
    go.addEventListener('click', () => toast({ type: 'info', id: 'sel-go', title: 'Abriendo Lunvelis World', message: 'Tus servicios se añaden al carrito de esa tienda. Ahí revisas el total y decides si pagas; Partners no cobra.' }));
    const clear = el('button', 'lp-sel__remove', 'Vaciar selección'); clear.type = 'button';
    clear.addEventListener('click', () => { api.clear(); toast({ type: 'info', id: 'sel-clear', title: 'Selección vaciada' }); });
    actions.append(go, clear);
    if (actions === host) { go.style.justifySelf = 'start'; }
  };

  const setup = () => {
    const pill = document.getElementById('lp-selection-pill');
    const dialog = document.getElementById('lp-selection');
    const list = dialog && dialog.querySelector('[data-lp-selection-list]');
    const foot = dialog && dialog.querySelector('[data-lp-selection-foot]');
    const refresh = () => {
      const count = api.count();
      if (pill) { pill.hidden = count === 0 || !!document.getElementById('lp-sel-mount'); const badge = pill.querySelector('[data-lp-selection-count]'); if (badge) badge.textContent = String(count); }
      if (dialog && list && dialog.open) paint(list, foot);
      const mount = document.getElementById('lp-sel-mount');
      if (mount) paint(mount.querySelector('[data-lp-sel-body]'), null);
      for (const button of document.querySelectorAll('[data-lp-add]')) {
        const on = api.has(button.dataset.lpAdd);
        button.setAttribute('aria-pressed', String(on));
        button.textContent = on ? 'En mi selección · Quitar' : 'Añadir a mi selección';
      }
    };
    document.addEventListener('lp:selection', refresh);
    window.addEventListener('storage', (event) => { if (event.key === KEY) refresh(); });
    if (pill && dialog && typeof dialog.showModal === 'function') {
      pill.addEventListener('click', () => { paint(list, foot); dialog.showModal(); });
      dialog.addEventListener('click', (event) => { if (event.target === dialog || event.target.closest('[data-lp-close]')) dialog.close(); });
    }
    /* Página del carrito: la selección aparece junto al carrito de Partners. */
    if (document.body.classList.contains('lp-shell--store') && /^\/cart\/?$/.test(location.pathname)) {
      const anchor = document.querySelector('#MainContent .shopify-section');
      if (anchor && !document.getElementById('lp-sel-mount')) {
        const mount = el('section', 'lp-sel-mount'); mount.id = 'lp-sel-mount'; mount.setAttribute('aria-labelledby', 'lp-sel-mount-title');
        const h = el('h2', '', 'Tu selección de servicios de Lunvelis World'); h.id = 'lp-sel-mount-title';
        const p = el('p', '', 'Esta tienda es el espacio de Partners. Los servicios del catálogo se contratan en Lunvelis World: aquí puedes elegirlos, ajustar cantidades y ver el total antes de continuar.');
        const body = el('div'); body.dataset.lpSelBody = '';
        mount.append(h, p, body);
        anchor.after(mount);
        const wrapper = el('div'); wrapper.style.cssText = 'padding-inline:var(--lp-gutter,20px);padding-block-end:64px'; mount.before(wrapper); wrapper.append(mount);
      }
    }
    refresh();
  };

  /* Botones «Añadir a mi selección» del catálogo (delegados: se crean dinámicamente). */
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-lp-add]');
    if (!button) return;
    const variant = button.dataset.lpAdd;
    if (api.has(variant)) { api.remove(variant); toast({ type: 'info', id: `sel-${variant}`, title: 'Servicio quitado de tu selección', message: button.dataset.lpTitle }); return; }
    api.add({ variant, handle: button.dataset.lpHandle, title: button.dataset.lpTitle, area: button.dataset.lpArea, kind: button.dataset.lpKind, price: Number(button.dataset.lpPrice) });
    if (window.LunvelisFx) window.LunvelisFx.confetti(button, { count: 22, spread: 0.7 });
    toast({ type: 'success', id: `sel-${variant}`, title: 'Añadido a tu selección', message: `${button.dataset.lpTitle} · ${money.format(Number(button.dataset.lpPrice))}`, action: { label: 'Ver selección', onClick: () => document.getElementById('lp-selection-pill')?.click() } });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
